import { getFacilitiesWithIcons } from '@/utils/webbedFaciltiyIcons';
import { useState, useEffect } from 'react';

type Facility = {
  name: string;
  icon: string;
  _id: string;
};

type FacilsState = {
  iconName: string;
  iconElement: JSX.Element | null;
};

const useFacilitiesWithIcons = (facilities: Facility[]) => {
  const [facils, setFacils] = useState<FacilsState[]>([]);

  useEffect(() => {
    const handleGetFacils = async () => {
      setFacils(await getFacilitiesWithIcons(facilities));
    };
    
    handleGetFacils();
  }, [facilities]);

  return facils;
};

export default useFacilitiesWithIcons;
